import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { getStore } from '../store/store';
import { getMailboxKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export function getLinkedLicensingMailboxConfig(
    mailboxInfo: MailboxInfo
): OwaUserConfiguration | undefined {
    const mailboxKey = getMailboxKeyForMailboxInfo(mailboxInfo);
    return getStore().linkedLicensingMailboxConfigs.get(mailboxKey);
}
